import React from "react";
import { Button, Col, FormGroup, Input, Label, Row } from "reactstrap";

import SearchBox from "components/SearchBox";

export default function AdminListControls({
  search,
  onSearch,
  searchPlaceholder,
  filters = [],
  sortValue,
  onSortChange,
  sortOptions = [],
  onReset,
  resultCount,
  totalCount,
}) {
  return (
    <>
      <Row className="align-items-end">
      <Col lg="4" md="12">
        <SearchBox value={search} onChange={onSearch} placeholder={searchPlaceholder || "Ara..."} />
      </Col>

      {filters.map((filter) => (
        <Col lg="2" md="4" sm="6" key={filter.key}>
          <FormGroup>
            <Label className="form-control-label">{filter.label}</Label>
            <Input type="select" value={filter.value} onChange={(event) => filter.onChange(event.target.value)}>
              {filter.options.map((option) => (
                <option key={`${filter.key}-${option.value}`} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Input>
          </FormGroup>
        </Col>
      ))}

      <Col lg="2" md="4" sm="6">
        <FormGroup>
          <Label className="form-control-label">Sıralama</Label>
          <Input type="select" value={sortValue} onChange={(event) => onSortChange(event.target.value)}>
            {sortOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Input>
        </FormGroup>
      </Col>

        {onReset ? (
          <Col lg="2" md="4" sm="6">
            <FormGroup>
              <Label className="form-control-label d-block">&nbsp;</Label>
              <Button color="secondary" outline block onClick={onReset} type="button">
                Temizle
              </Button>
            </FormGroup>
          </Col>
        ) : null}
      </Row>

      {typeof resultCount === "number" ? (
        <div className="small text-muted mt-2">
          {resultCount} kayıt gösteriliyor{typeof totalCount === "number" ? ` / ${totalCount}` : ""}
        </div>
      ) : null}
    </>
  );
}